export default __webpack_public_path__ + "static/media/icon-home-add-hover.da846547.svg";